import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  CanhotoPrestacaoContasStatus,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomInputTextArea,
  CustomModal,
  CustomMultiSelect,
  CustomPanel,
  ImportExcelFile,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useValidacaoCanhoto, { DROPDOWN_OPTIONS, LOAD_MESSAGE, STATUS } from './ValidacaoCanhotoHook'
import ModalValidacaoCanhoto from './ValidacaoCanhotoModal/ModalValidacaoCanhoto'
import ModalAssociarClienteCanhoto from './ModalAssociarClienteCanhoto/ModalAssociarClienteCanhoto'
import { SplitButton } from 'primereact/splitbutton'

function ValidacaoCanhoto({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useValidacaoCanhoto()

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_CANHOTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        if (selectedTp === 0) {
          const tps = getTps(false).map(tp => tp.id)
          localDispatch.getCanhotos(
            tps,
            state.selectedStatus,
            state.periodo.dataInicial,
            state.periodo.dataFinal,
          )
        } else
          localDispatch.getCanhotos(
            [selectedTp],
            state.selectedStatus,
            state.periodo.dataInicial,
            state.periodo.dataFinal,
          )
        break

      case LOAD_MESSAGE.UPDATE_CANHOTO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.updateCanhotosStatus(
          state.canhotos.filter(c => c.selected).map(c => c.id),
          state.statusToUpdate,
        )
        break

      case LOAD_MESSAGE.UPLOAD_CANHOTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.importarCanhotos(state.fileContent, selectedTp)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const splitButtonStatusItems = [
    {
      label: 'Recusado',
      icon: 'pi pi-times',
      command: () => localDispatch.onButtonStatusClick(STATUS.RECUSADO, state.canhotos),
    },
    {
      label: 'Pendente',
      icon: 'pi pi-exclamation-triangle',
      command: () => localDispatch.onButtonStatusClick(STATUS.PENDENTE, state.canhotos),
    },
  ]

  return (
    <>
      <PageHeader>6.5 - Validação de Canhoto</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onNovoClick(selectedTp)}
          showBtnNovo={false}
          onVoltar={history.goBack}
        >
          <div className="p-grid p-align-center">
            <div className="p-col-2">
              <CustomMultiSelect
                options={DROPDOWN_OPTIONS}
                label="Status"
                value={state.selectedStatus}
                onChange={localDispatch.onStatusSelectedChange}
              />
            </div>
            <div className="p-col-4">
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onBtnPesquisarClick(pInicial, pFinal)
                }
              />
            </div>
            <div
              className="p-col-fixed p-grid-col p-align-end"
              style={{ width: '240px', paddingTop: '15px' }}
            >
              <span style={{ fontSize: '0.8rem', color: 'rgb(20, 176, 191)', display: 'block' }}>
                Canhotos:
              </span>
              <div className="p-col-12">
                <Btn onClick={() => localDispatch.onBtnExportarExcel(state.canhotos)}>
                  <i className="pi pi-download"></i> Exportar
                </Btn>
                <ImportExcelFile
                  label="Importar"
                  classes="btnImportar"
                  hasIcon={true}
                  onFileImported={content => localDispatch.onBtnImportarClick(content)}
                />
              </div>
            </div>
            <div className="p-col-2 p-grid-col p-align-end">
              <span style={{ fontSize: '0.8rem', color: 'rgb(20, 176, 191)', display: 'block' }}>
                Alterar status:{' '}
              </span>
              <SplitButton
                style={{ paddingTop: '5px' }}
                label="OK"
                icon="pi pi-check"
                onClick={() => localDispatch.onButtonStatusClick(STATUS.OK, state.canhotos)}
                model={splitButtonStatusItems}
                className="p-button-secondary"
              ></SplitButton>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.canhotos}
                emptyMessage={'Não existe movimentação para o Período selecionado'}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
                globalFilter={state.globalFilter}
              >
                <Column
                  header="#"
                  style={tableCellCentered(80)}
                  body={canhoto => (
                    <CustomCheckbox
                      checked={canhoto.selected}
                      onChange={() => localDispatch.onItemClicked(canhoto)}
                    />
                  )}
                />
                <Column field="prestacao_contas_data" header="Data" style={tableCellCentered()} />
                <Column
                  field="transportadora_name"
                  header="Transportadora"
                  style={tableCellCentered()}
                />
                <Column
                  field={'num_nf_canhoto'}
                  header={'NF. Canhoto'}
                  style={tableCellCentered(120)}
                />
                <Column
                  field={'patrimonio_name'}
                  header={'Patrimonio'}
                  style={tableCellCentered(120)}
                />
                <Column field={'qte'} header={'Qte'} style={tableCellCentered(120)} />
                <Column
                  header={'Status'}
                  style={tableCellCentered(150)}
                  body={canhoto => <CanhotoPrestacaoContasStatus status={canhoto.status} />}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={data => (
                    <ThreeDots
                      items={localDispatch.getMenuItems()}
                      onClick={item => localDispatch.onMenuItemClick(item, data, history, selectedTp)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
        <ModalValidacaoCanhoto modal={state.modal} onResponse={localDispatch.onResponse} />
        <ModalAssociarClienteCanhoto
          isVisible={state.clienteModal.show}
          canhotoId={state.clienteModal.canhotoId}
          canhotoLabel={state.clienteModal.canhotoLabel}
          clienteAssociado={state.clienteModal.clienteAssociado}
          onClose={localDispatch.closeClienteModal}
          onSave={localDispatch.saveClienteId}
        />
        <CustomModal
          isVisible={state.observacaoModal.show}
          header={`Observação - NF: ${state.observacaoModal.canhotoLabel}`}
          width={600}
          onClose={localDispatch.closeObservacaoModal}
        >
          <div className="p-grid">
            <div className="p-col-12">
              <CustomInputTextArea
                label="Observação"
                value={state.observacaoModal.observacao}
                onChange={localDispatch.onObservacaoChange}
                rows={5}
              />
            </div>
            <div className="p-col-12" style={{ textAlign: 'right', marginTop: 10 }}>
              <Btn
                onClick={() =>
                  localDispatch.saveObservacao(
                    state.observacaoModal.canhotoId,
                    state.observacaoModal.observacao,
                  )
                }
              >
                Salvar
              </Btn>
            </div>
          </div>
        </CustomModal>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ValidacaoCanhoto))
